// Components
import { useCallback, useEffect } from 'react';
import DiscardConfirmation, {
  useDiscardConfirmation,
} from 'components/DiscardConfirmation';
// i18N
import { getText } from 'i18n/intl';
import { requestObjectTypes } from 'slices/objectTypes.slice';
import {
  checkRelationTypeSaveDisabled,
  fetchRelationTypes,
} from 'slices/relationType.slice';
// Slices
import { fetchReservationTemplates } from 'slices/reservationTemplate.slice';
import { useAppDispatch } from 'slices/store';
import { DefaultContentLayout } from '@timeedit/ui-components';
import RelationTypeDrawer from './RelationTypeDrawer';
import RelationTypeList from './RelationTypeList';

const RelationTypePage = () => {
  const dispatch = useAppDispatch();
  const [
    openDiscardDialog,
    onCloseDiscardDialog,
    confirmFn,
    confirmDiscardChanged,
  ] = useDiscardConfirmation();

  useEffect(() => {
    dispatch(fetchRelationTypes());
    dispatch(fetchReservationTemplates());
    dispatch(requestObjectTypes());
  }, [dispatch]);

  const confirmDiscardRelationTypeChanges = useCallback(
    (isFirstDrawer: boolean, actionFn: () => void) => {
      const isRelationTypeDisabled = dispatch(
        checkRelationTypeSaveDisabled(isFirstDrawer)
      );
      if (!isRelationTypeDisabled) {
        return confirmDiscardChanged(actionFn);
      }
      actionFn();
    },
    []
  );

  return (
    <DefaultContentLayout
      title={getText('relations')}
      subtitle={getText('relations_subtitle')}
    >
      <div className="inner-content--wrapper">
        <RelationTypeList
          confirmDiscardChanges={confirmDiscardRelationTypeChanges}
        />
        <RelationTypeDrawer
          confirmDiscardChanges={confirmDiscardRelationTypeChanges}
        />
        <DiscardConfirmation
          open={openDiscardDialog}
          onClose={onCloseDiscardDialog}
          confirmFn={confirmFn}
        />
      </div>
    </DefaultContentLayout>
  );
};

export default RelationTypePage;
